import { useTypedParams } from '@sorare/routing';

import { ScoutingCenter } from '#src/components/scoutingCenter/ScoutingCenter/index.tsx';

import type { PageParams } from './__generated__/routeParams.ts';

const ScoutingCenterSo5CompetitionPage = () => {
  const { slug } = useTypedParams<PageParams>();
  return <ScoutingCenter slug={slug} />;
};

export default ScoutingCenterSo5CompetitionPage;
